import { render, staticRenderFns } from "./form-tag.vue?vue&type=template&id=12e24f5a&scoped=true&lang=pug"
import script from "./form-tag.vue?vue&type=script&lang=js"
export * from "./form-tag.vue?vue&type=script&lang=js"
import style0 from "./form-tag.vue?vue&type=style&index=0&id=12e24f5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e24f5a",
  null
  
)

export default component.exports